import { getImageUrl } from "@erp/shared/api/generated/wrappers/s3";
import { getBlobType } from "./get-blob-type";
import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { extractOriginalName } from "./file-name";
/**
 * 파일 데이터를 File 객체로 변환
 * @param fileName 파일명
 * @returns File 객체
 */
export const convertToFileObj = async (fileName) => {
    try {
        const mimeType = getBlobType(fileName);
        const url = await getImageUrl(fileName);
        const response = await fetch(url);
        const blob = await response.blob();
        const formatedFileName = `${extractOriginalName(fileName)}`;
        if (!formatedFileName) {
            throw new Error("파일명을 추출할 수 없습니다.");
        }
        return new File([blob], formatedFileName, { type: mimeType });
    }
    catch (error) {
        showAlert(getErrorMessage(error));
        return null;
    }
};
